// Application-managed enum for the `base_table` column on
// `CustomReport`, `SocietyDashboardModule`, and `SocietyDefaultReport`.
//
// Previously this was a Postgres enum (`public.base_table`) generated into
// `prisma-generated`. The DB column is now a plain TEXT column so this enum
// is the single source of truth for valid values.
export enum base_table {
  society = "society",
  profile = "profile",
  invoice = "invoice",
  invoiceItem = "invoiceItem",
  payment = "payment",
  paymentInvoiceItem = "paymentInvoiceItem",
  submissionInstance = "submissionInstance",
  reviewReport = "reviewReport",
  raw_query = "raw_query",
  conference_registration = "conference_registration",
  workflow = "workflow",
  workflow_instance = "workflow_instance",
  workflow_instance_batch = "workflow_instance_batch",
  workflow_instance_payload_scalar = "workflow_instance_payload_scalar",
  workflow_instance_payload_paneldynamic = "workflow_instance_payload_paneldynamic",
  workflow_instance_payload_profilesearch = "workflow_instance_payload_profilesearch",
  workflow_instance_payload_education_instance = "workflow_instance_payload_education_instance",
  workflow_instance_payload_certification_attribution_table_view = "workflow_instance_payload_certification_attribution_table_view",
  group_member = "group_member",
  group_type = "group_type",
  membership = "membership",

  review_sessions = "review_sessions",
  review_session_member = "review_session_member",
  review_instances = "review_instances",
  review_instance_assignments = "review_instance_assignments",
  conference_event = "conference_event",
  conference_event_submission = "conference_event_submission",
  conference_event_participant = "conference_event_participant",
  conference_event_favorite = "conference_event_favorite",
  conference_event_attendee = "conference_event_attendee",
  conference_day = "conference_day",

  society_custom_choice = "society_custom_choice",

  contact_information = "contact_information",
  address = "address",
}
